import { render, staticRenderFns } from "./Articulo.vue?vue&type=template&id=78d6fb9d&"
import script from "./Articulo.vue?vue&type=script&lang=js&"
export * from "./Articulo.vue?vue&type=script&lang=js&"
import style0 from "./Articulo.vue?vue&type=style&index=0&id=78d6fb9d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports